import { Controller } from "@hotwired/stimulus"

// The work register's owner picker (playbook/_duty_register). One picker for
// every row: opening a row's owner chip moves it into that chip's menu, points
// it at the duty, and lifts the suggested role's people to the top. Picking a
// person submits "user_id|role" to PlaybookController#assign_duty.
export default class extends Controller {
    static targets = ["form", "input", "list", "group", "item", "empty"]

    open(event) {
        let chip = event.target.closest(".playbook-owner-chip")
        if (!chip) return

        let menu = chip.parentElement.querySelector(".playbook-owner-menu")
        this.formTarget.action = chip.dataset.assignUrl
        menu.appendChild(this.formTarget)
        this.inputTarget.value = ""
        this.filter()
        this._liftSuggested(chip.dataset.suggested)
        requestAnimationFrame(() => this.inputTarget.focus())
    }

    filter() {
        let query = this._fold(this.inputTarget.value)
        let shown = 0
        this.itemTargets.forEach((item) => {
            let match = !query || this._fold(item.dataset.name).includes(query)
            item.hidden = !match
            if (match) shown += 1
        })
        this.groupTargets.forEach((group) => {
            group.hidden = !group.querySelector(".playbook-owner-option:not([hidden])")
        })
        this.emptyTarget.hidden = shown > 0
    }

    // Enter picks the only person left.
    keydown(event) {
        if (event.key !== "Enter") return

        event.preventDefault()
        let visible = this.itemTargets.filter((item) => !item.hidden)
        if (visible.length === 1) visible[0].click()
    }

    // The suggested role's group first, the rest in their Team page order.
    _liftSuggested(role) {
        if (!this.order) this.order = [...this.groupTargets]
        let key = this._fold(role)
        let match = key && this.order.find((group) => this._fold(group.dataset.role).startsWith(key))
        let ordered = match ? [match, ...this.order.filter((group) => group !== match)] : this.order
        ordered.forEach((group) => {
            group.classList.toggle("is-suggested", group === match)
            this.listTarget.appendChild(group)
        })
    }

    _fold(value) {
        return String(value || "").normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase().trim()
    }
}
